/* eslint-disable no-empty */
import { textactive } from "@/_core/_helpers/_parametric_tools";
import {
  barrierColor,
  dashArray,
  dataForBarriers,
  isBarrier,
} from "../../charts/D3Chart";
import { curveLinear, line as lineD3, select, timeFormat } from "d3";
import {
  colorDarkExpo,
  darkBackground4,
  textactive2,
} from "../../_helpers/_parametric_tools";
import {
  dateInterpolate,
  vLineCreate,
} from "@/_core/charts/D3ChartHoverHelpers";
import {
  derivativesTooltipTxt,
  ratesSmTooltip,
} from "@/_core/charts/D3ChartAnalyticsChartHelpers";
import {
  derivativeImage,
  derivativeImageHighlight,
} from "@/_core/charts/D3ChartAnalyticsChartHelpers";
import lCall from "@/assets/images/lCall.svg";
import lCallOff from "@/assets/images/lCallA.svg";
import lCallOn from "@/assets/images/lCallH.svg";
import lFwd from "@/assets/images/lFwd.svg";
import lFwdOff from "@/assets/images/lFwdA.svg";
import lFwdOn from "@/assets/images/lFwdH.svg";
import lPut from "@/assets/images/lPut.svg";
import lPutOff from "@/assets/images/lPutA.svg";
import lPutOn from "@/assets/images/lPutH.svg";
import sCall from "@/assets/images/sCall.svg";
import sCallOff from "@/assets/images/sCallA.svg";
import sCallOn from "@/assets/images/sCallH.svg";
import sFwd from "@/assets/images/sFwd.svg";
import sFwdOff from "@/assets/images/sFwdA.svg";
import sFwdOn from "@/assets/images/sFwdH.svg";
import sPut from "@/assets/images/sPut.svg";
import sPutOff from "@/assets/images/sPutA.svg";
import sPutOn from "@/assets/images/sPutH.svg";

export class Scatter {
  constructor(svg, svgAux = null) {
    this.svg = svg;
    this.svgAux = svgAux ? svgAux : svg;
  }

  scatter({
    data,
    xField = "rates",
    yField = "rates",
    fillColor = textactive,
    fillOpacity = 1,
    strokeOpacity = 1,
    lineColor = textactive,
    lineWidth = 1,
    radius = 3,
    className = "scatter",
  }) {
    this.svg
      .append("g")
      .selectAll("dot")
      .data(data)
      .enter()
      .append("circle")
      .attr("cx", (d) => {
        return this.svg.x(d[xField]);
      })
      .attr("cy", (d) => {
        return this.svg.y(d[yField]);
      })
      .attr("r", radius)
      .style("fill", fillColor)
      .attr("fill-opacity", fillOpacity)
      .style("stroke", lineColor)
      .style("stroke-opacity", strokeOpacity)
      .attr("stroke-width", lineWidth)
      .attr("class", (d, i) => `${className}${i}`)
      .style("shape-rendering", "crispEdges")
      .style("vector-effect", "non-scaling-stroke");
  }
  scatterImg({
    data,
    groupField,
    customName,
    numberFormat,
    currencyFormat,
    dateFormat,
    baseC,
    imgURL,
    imgURLOff,
    xRange,
    derivativeSize,
    lFwdURL = lFwd,
    sFwdURL = sFwd,
    lCallURL = lCall,
    sCallURL = sCall,
    lPutURL = lPut,
    sPutURL = sPut,
    lFwdHURL = lFwdOn,
    sFwdHURL = sFwdOn,
    lCallHURL = lCallOn,
    sCallHURL = sCallOn,
    lPutHURL = lPutOn,
    sPutHURL = sPutOn,
    lFwdAURL = lFwdOff,
    sFwdAURL = sFwdOff,
    lCallAURL = lCallOff,
    sCallAURL = sCallOff,
    lPutAURL = lPutOff,
    sPutAURL = sPutOff,
    lFField,
    sFField,
    lCField,
    sCField,
    lPField,
    sPField,
    showTooltipDeriv,
    isFuture,
    asset = "commodities",
    adjustTooltip = false,
    colorTheme,
    isAnalytics = false,
    chartBody,
    dateFld = "date",
  }) {
    const svg = this.svg;
    let svgAux = chartBody ? chartBody : this.svgAux;

    let mainFields = [lFField, sFField, lCField, sCField, lPField, sPField];
    let mainUrls = [lFwdURL, sFwdURL, lCallURL, sCallURL, lPutURL, sPutURL];
    let mainHUrls = [
      lFwdHURL,
      sFwdHURL,
      lCallHURL,
      sCallHURL,
      lPutHURL,
      sPutHURL,
    ];
    let mainAUrls = [
      lFwdAURL,
      sFwdAURL,
      lCallAURL,
      sCallAURL,
      lPutAURL,
      sPutAURL,
    ];
    vLineCreate(svg, "RATES", "gray", 1);
    let sharp = "#";
    let tooltipWidth = 500;
    let Tooltip;
    let Tooltip2 = select(`${sharp}${svg.parentElement}`)
      .append("div")
      .style("opacity", 0)
      .style("margin", "0 auto")
      .style("text-align", "center")
      .style("padding", "2px")
      .style("background", colorDarkExpo(colorTheme))
      .style("border", colorDarkExpo(colorTheme))
      .style("color", textactive2(colorTheme))
      .attr("class", "tooltip")
      .style("font-size", "0.8rem")
      .style("width", "auto")
      .html("");
    let tooltipWidth2 = 80;
    let Tooltip3 = select(`${sharp}${svg.parentElement}`)
      .append("div")
      .style("opacity", 0)
      .style("margin", 0)
      .style("text-align", "center")
      .style("padding", "2px")
      .style("background", colorDarkExpo(colorTheme))
      .style("border", colorDarkExpo(colorTheme))
      .style("color", textactive2(colorTheme))
      .attr("class", "tooltip")
      .style("width", tooltipWidth2 + "px")
      .html("");
    if (showTooltipDeriv) {
      Tooltip = select(`${sharp}${svg.parentElement}`)
        .append("div")
        .style("opacity", 0)
        .style("width", tooltipWidth + "px")
        .style("padding", "2px")
        .style("background", darkBackground4(colorTheme))
        .attr("class", "tooltip");
    } else {
      Tooltip = select(`${sharp}${svg.parentElement}`)
        .append("div")
        .style("opacity", 0)
        .style("margin", "0 auto")
        .style("text-align", "center")
        .style("padding", "0")
        .attr("class", "tooltip tooltip-transparent")
        .style("font-size", "0.5rem")
        .style("width", 0.95 * svg.width + "px")
        .style("line-height", "1")
        .html("");
    }

    var mousemove = function(d) {
      event.preventDefault();
      const yPixels = Math.max(
        Math.min(event.layerY - svg.margin.top, svg.height),
        0,
      );
      const xPixels = Math.max(
        Math.min(event.layerX - svg.margin.left, svg.width),
        0,
      );

      select(".hHoverLineRATES")
        .style("opacity", 1)
        .attr("y1", svg.y(d.strike))
        .attr("y2", svg.y(d.strike));
      select(".vHoverLineRATES")
        .style("opacity", 1)
        .attr(
          "x1",
          dateInterpolate(xRange, d[dateFld], svg.x, svg.x.bandwidth()),
        )
        .attr(
          "x2",
          dateInterpolate(xRange, d[dateFld], svg.x, svg.x.bandwidth()),
        );
      select(".hHoverLineTA")
        .style("opacity", 1)
        .attr("y1", svg.y(d.strike))
        .attr("y2", svg.y(d.strike));
      Tooltip2.style("opacity", 1)
        .style("left", svg.width + svg.margin.left + 1 + "px")
        .style("top", svg.y(d.strike) + "px")
        .html(currencyFormat(d.strike));

      let txt;
      if (showTooltipDeriv) {
        txt = derivativesTooltipTxt(
          d,
          numberFormat,
          currencyFormat,
          baseC,
          derivativeSize,
          lFwdURL,
          sFwdURL,
          lCallURL,
          sCallURL,
          lPutURL,
          sPutURL,
          isFuture,
          asset,
        );
      } else {
        txt = ratesSmTooltip(
          d,
          numberFormat,
          currencyFormat,
          baseC,
          derivativeSize,
          lFwdURL,
          sFwdURL,
          lCallURL,
          sCallURL,
          lPutURL,
          sPutURL,
          asset,
        );
      }

      let bool = false;
      if (adjustTooltip) {
        let scrnW = document.getElementById("whole-page-div").clientWidth;
        bool =
          0.5 * scrnW +
            dateInterpolate(xRange, d[dateFld], svg.x, svg.x.bandwidth()) +
            svg.margin.left +
            tooltipWidth +
            (scrnW * 2) / 12 >
          scrnW;
      }

      let posAu = xPixels > 0.45 * svg.width || bool ? tooltipWidth + 10 : -10;
      let posTop, posBottom;

      if (showTooltipDeriv) {
        if (yPixels < 0.85 * svg.height) {
          posTop = yPixels + svg.margin.top + 10 + "px";
          posBottom = null;
        } else {
          posTop = null;
          posBottom = svg.height + svg.margin.bottom - yPixels + 10 + "px";
        }
        Tooltip.style("opacity", 1)
          .style("left", xPixels - posAu + "px")
          .style("top", posTop)
          .style("bottom", posBottom)
          .html(txt);
      } else {
        Tooltip.style("opacity", 1)
          .style("left", svg.margin.left + 1 + "px")
          .style("top", svg.margin.top + 1 + "px")
          .html(txt);
      }

      posAu =
        showTooltipDeriv && posBottom === null
          ? xPixels < 0.45 * svg.width
            ? tooltipWidth2
            : 0
          : tooltipWidth2 / 2;
      Tooltip3.style("opacity", 1)
        .style(
          "left",
          dateInterpolate(xRange, d[dateFld], svg.x, svg.x.bandwidth()) -
            posAu +
            "px",
        )
        .style("top", svg.height + svg.margin.top + 1 + "px")
        .html(timeFormat(dateFormat)(d[dateFld]));

      select(this)
        .attr(
          "xlink:href",
          derivativeImageHighlight(
            d,
            lFwdHURL,
            sFwdHURL,
            lCallHURL,
            sCallHURL,
            lPutHURL,
            sPutHURL,
          ),
        )
        .attr("width", derivativeSize * 1.1)
        .attr("height", derivativeSize * 1.1);

      for (let i = 0; i < mainFields.length; i++) {
        // --- images highlight - alpha
        try {
          svg[mainFields[i]]
            .selectAll("image")
            .data(function(d) {
              return d;
            })
            .attr("xlink:href", (dat) =>
              dat.strategy_code === d.strategy_code
                ? mainHUrls[i]
                : mainAUrls[i],
            );
        } catch {}

        // --- rect highlight - alpha
        try {
          svg[mainFields[i] + "Rect"]
            .selectAll("rect")
            .data(function(dat) {
              return dat;
            })
            .attr("stroke", (dat) =>
              barrierColor(
                mainFields[i],
                dat.strategy_code !== d.strategy_code,
              ),
            )
            .style("fill", function(dat) {
              return dat.derivative_type.indexOf("OUT") > -1
                ? "rgba(0,0,0,0)"
                : barrierColor(
                    mainFields[i],
                    dat.strategy_code !== d.strategy_code,
                  );
            });
        } catch {}
      }

      // -- historical data line
      if (d.historicalIndex > -1) {
        select(".bandsTA" + d.historicalIndex).classed("hoved", true);
        select(".stickTA" + d.historicalIndex).classed("hoved", true);
        select(".stick2TA" + d.historicalIndex).classed("hoved", true);
        select(".candleTA" + d.historicalIndex).classed("hoved", true);
      }
    };
    var mouseleave = function(d) {
      Tooltip.style("left", "-1000000px")
        .style("top", "0px")
        .style("opacity", 0)
        .html("");
      select(".hHoverLineRATES")
        .style("opacity", 0)
        .attr("display", null);
      select(".vHoverLineRATES")
        .style("opacity", 0)
        .attr("display", null);
      select(".hHoverLineTA")
        .style("opacity", 0)
        .attr("display", null);
      Tooltip2.style("left", "-1000000px")
        .style("top", "0px")
        .style("opacity", 0)
        .html("");
      Tooltip3.style("left", "-1000000px")
        .style("top", "0px")
        .style("opacity", 0)
        .html("");
      select(this)
        .attr(
          "xlink:href",
          derivativeImage(
            d,
            lFwdURL,
            sFwdURL,
            lCallURL,
            sCallURL,
            lPutURL,
            sPutURL,
          ),
        )
        .attr("width", derivativeSize)
        .attr("height", derivativeSize);

      for (let i = 0; i < mainFields.length; i++) {
        // --- images highlight - alpha
        try {
          svg[mainFields[i]]
            .selectAll("image")
            .data(function(d) {
              return d;
            })
            .attr("xlink:href", (d) =>
              d.derivative_type.indexOf("OUT") > -1 && d.new_event
                ? mainAUrls[i]
                : mainUrls[i],
            );
        } catch {}

        // --- line highlight - alpha
        try {
          svg[mainFields[i] + "Stick"].attr("stroke", (d) =>
            barrierColor(
              mainFields[i],
              d.derivative_type.indexOf("OUT") > -1
                ? d.new_event
                : !d.new_event,
            ),
          );
        } catch {}

        // --- rect highlight - alpha
        try {
          svg[mainFields[i] + "Rect"]
            .selectAll("rect")
            .data(function(d) {
              return d;
            })
            .attr("stroke", (d) =>
              barrierColor(
                mainFields[i],
                d.derivative_type.indexOf("OUT") > -1
                  ? d.new_event
                  : !d.new_event,
              ),
            )
            .style("fill", function(d) {
              return d.derivative_type.indexOf("OUT") > -1
                ? "rgba(0,0,0,0)"
                : barrierColor(
                    mainFields[i],
                    d.derivative_type.indexOf("OUT") > -1
                      ? d.new_event
                      : !d.new_event,
                  );
            });
        } catch {}
      }

      if (d.historicalIndex > -1) {
        select(".bandsTA" + d.historicalIndex).classed("hoved", false);
        select(".stickTA" + d.historicalIndex).classed("hoved", false);
        select(".stick2TA" + d.historicalIndex).classed("hoved", false);
        select(".candleTA" + d.historicalIndex).classed("hoved", false);
      }
    };

    // --- barriers
    let barrierData = data.filter((d) => isBarrier(d.derivative_type));
    if (barrierData.length > 0) {
      let widthRect = 15;
      // strike - barrier line
      let newData = dataForBarriers(barrierData, dateFld);
      var line = lineD3()
        .curve(curveLinear)
        .defined((d) => d.y)
        .x((d) => dateInterpolate(xRange, d[dateFld], svg.x, svg.x.bandwidth()))
        .y((d) => svg.y(d.y));

      svg[groupField + "Stick"] = svgAux
        .append("g")
        .attr("class", "sticks" + customName)
        .attr("fill", "none")
        .attr("stroke-linejoin", "round")
        .attr("stroke-linecap", "round")
        .selectAll("path")
        .data(newData.series, (d) => d.id)
        .join("path")
        .style("stroke", barrierColor(groupField, true))
        .style("stroke-width", 1)
        .style("stroke-dasharray", dashArray(customName))
        .attr("d", (d) => line(d.values))
        .style("shape-rendering", "crispEdges")
        .style("vector-effect", "non-scaling-stroke");

      // barrier rectangle
      svg[groupField + "Rect"] = svgAux
        .selectAll(".barrierRect" + customName)
        .data([barrierData])
        .enter()
        .append("g")
        .attr("class", "barrierRect" + customName);
      svg[groupField + "Rect"]
        .selectAll("rect")
        .data(function(d) {
          return d;
        })
        .enter()
        .append("rect")
        .attr("x", function(d) {
          return (
            dateInterpolate(xRange, d[dateFld], svg.x, svg.x.bandwidth()) -
            widthRect / 2
          );
        })
        .attr("y", function(d) {
          return svg.y(d.barrier) - 2;
        })
        .attr("height", "2px")
        .attr("width", widthRect + "px")
        .attr("stroke-width", 1)
        .attr("stroke", (d) =>
          barrierColor(
            groupField,
            d.derivative_type.indexOf("OUT") > -1 ? d.new_event : !d.new_event,
          ),
        )
        .style("fill", function(d) {
          return d.derivative_type.indexOf("OUT") > -1
            ? "rgba(0,0,0,0)"
            : barrierColor(
                groupField,
                d.derivative_type.indexOf("OUT") > -1
                  ? d.new_event
                  : !d.new_event,
              );
        });
    }
    const svgBodyImages = isAnalytics ? svgAux : svg;
    // --- derivative images
    svg[groupField] = svgBodyImages
      .selectAll(".scatter" + customName)
      .data([data])
      .enter()
      .append("g")
      .attr("class", ".scatter" + customName);
    svg[groupField]
      .selectAll("image")
      .data(function(d) {
        return d;
      })
      .enter()
      .append("image")
      .attr("xlink:href", (d) =>
        d.derivative_type.indexOf("OUT") > -1 && d.new_event
          ? imgURLOff
          : imgURL,
      )
      .attr("x", function(d) {
        return (
          dateInterpolate(xRange, d[dateFld], svg.x, svg.x.bandwidth()) -
          derivativeSize / 2
        );
      })
      .attr("y", function(d) {
        return svg.y(d.strike) - derivativeSize / 2;
      })
      .attr("width", derivativeSize)
      .attr("height", derivativeSize)
      .on("mouseover", mousemove)
      .on("mouseleave", mouseleave)
      .on("mousemove", mousemove);
  }
}
